import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";



export class DynamicForm {

  constructor(private $log: Logger, private $utils: Utils) {
    const forms: NodeListOf<HTMLFormElement> = document.querySelectorAll('form[name="ercas_form"]');

    forms?.forEach((form) => {
      this.initDynamicForm(form);
    });
  }

  private initDynamicForm(form: HTMLFormElement) {
    const dynamicFields: NodeListOf<HTMLElement> = form.querySelectorAll('[data-depending]');

    form.addEventListener('change', () => {
      dynamicFields?.forEach(field => {
        this.handleDynamicField(form, field);
      });
    }, {passive: true});


    dynamicFields?.forEach(field => {
      this.handleDynamicField(form, field, true);
    });
  }

  private handleDynamicField(form: HTMLFormElement, field: HTMLElement, init: boolean = false) {
    const dependings = JSON.parse(field.dataset.depending);
    const fieldName = field.dataset.name

    let visible: boolean = false;

    dependings?.forEach((depending: {dependingOn: string, dependingOnValue: string}) => {
      const {dependingOn, dependingOnValue} = depending;

      const formData = new FormData(form);

      const dependingValue: any = formData.get(`ercas_form[${dependingOn}]`);

      if (!(dependingValue && dependingOnValue)) {
        return;
      }

      if (dependingValue === dependingOnValue) {
        visible = true;
      }

    });

    const container = field.closest('.js-form-container');

    const inputs: NodeListOf<HTMLInputElement> = container?.querySelectorAll(`input[name*="ercas_form[${fieldName}]"]`);

    inputs?.forEach((input) => {
      if (input?.classList?.contains('filepond') && init === true) {
        return;
      }
      if (visible) {
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    });

    if (visible) {
      container.classList.remove('d-none');
    } else {
      container.classList.add('d-none');
    }
  }
}
